/**
 * Single source of monotonically increasing element UIDs.
 *
 * Historically, MergeEngine, IdleSystem, and GameScene each maintained their
 * own counter (issue #22). They produced overlapping sequences, which could
 * collide in the sprite map. UidAllocator replaces all three: every system
 * that mints a new ElementInstance gets its UID from the same instance.
 */
export class UidAllocator {
  private next: number;

  constructor(start: number = 1) {
    this.next = start;
  }

  /** Mint the next UID. */
  mint(): number {
    return this.next++;
  }

  /** Ensure the allocator is strictly greater than `uid` (used after save-load). */
  syncAbove(uid: number): void {
    if (uid >= this.next) this.next = uid + 1;
  }

  /** Peek at the next UID without consuming (tests only). */
  peek(): number {
    return this.next;
  }

  /** Reset to start value (tests only). */
  reset(start: number = 1): void {
    this.next = start;
  }
}
